import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { PayRocPageRoutingModule } from './payroc-routing.module';

import { PayRocPage } from './payroc.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    PayRocPageRoutingModule,
  ],
  declarations: [PayRocPage],
})
export class PayRocPageModule {}
